// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".productCard_3Kvhv{width:230px;min-height:200px}@media(min-width:1024px){.productCard_3Kvhv{width:315px}}", ""]);
// Exports
exports.locals = {
	"productCard": "productCard_3Kvhv"
};
module.exports = exports;
